module.exports = __webpack_public_path__ + "img/bunbunmaru newspaper.db113222.png";